
import React,{useContext, useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { SITE_TITLE, INDEX_URL } from '../../settings/common';
import {AppContext} from '../../helpers/AppContext';
import { seo } from '../../settings/seo';
import { decrypt } from '../../helpers/encryption';


const DashboardPage = () => {
	const [authUser, setAuthUser] = useState({});
    const [users, setUsers] = useState({});
    const {isSidebarHidden, setSidebarHidden } = useContext(AppContext);
	const { SharedAuthUser, setSharedAuthUser } = useContext(AppContext);
    
    useEffect(() => {
        const auth_user = decrypt('__bs_auth_user');
        if (Object.keys(SharedAuthUser).length > 0) {
            setAuthUser(SharedAuthUser);
        } else if (auth_user) {
            setAuthUser(auth_user);
        } else {
            setAuthUser({});
        }
    }, [SharedAuthUser]);

	useEffect(() => {
        seo({
            title: SITE_TITLE + ' || Dashboard',
            metaDescription: '',
        });
    },[]);
	
    return (
        <React.Fragment>
            <div className={`cx-main-content ${isSidebarHidden ?'sb-hide':'' }`}>
			<div className="cx-breadcrumb">
				<div className="cx-page-title">
					<h5>Dashboard</h5>
				</div>
				
			</div>
			<div className="row">
				<div className="col-xxl-8">
					<div className="col-md-12">
						<div className="cx-card revenue-overview">
							<div className="cx-card-header border-0">
								<h4 className="cx-card-title"></h4>
								
							</div>
							<div className="cx-card-content">
								<div className="row">
									<div className="col-md-12 text-center">
										{(!authUser.is_configure) ? 
											(
												<React.Fragment>
													<div className="cx-user-detail">
														<p>Set up your account for use WhatsApp Services.</p>
													</div>
													<Link to={`${INDEX_URL}wa-settings`}><button type="submit">WhatsApp Configuration Settings</button></Link>
												</React.Fragment>
											) :
											(
												<React.Fragment>
												</React.Fragment>
											)
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        </React.Fragment>
                                );
                            };
                            
export default DashboardPage;